import { Chip } from "@material-ui/core";
import { memo } from "react";
import { useRankingClienteService } from "../context/RankingClienteContext";

const SituationChip = ({ situation }) => {
  const { handleRemoveChip } = useRankingClienteService();

  return (
    <Chip
      key={situation.id}
      label={situation.desc}
      onDelete={() => {
        handleRemoveChip(situation);
      }}
      color={"primary"}
    />
  );
};

export default memo(SituationChip);
